const customFetch = async (endpoint, options = { method: 'POST' }) => {
  const token = localStorage.getItem('authToken');
  const headers = new Headers(options.headers);

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

  try {
    const response = await fetch(`${baseUrl}/${endpoint}`, {
      mode: 'cors',
      ...options,
      headers,
    });

    if (response.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userRoleName');
      window.location.href = '/login';
      return Promise.reject({ message: 'セッションが期限切れです。再ログインしてください。' });
    }

    if (!response.ok) {
      const errorData = await response.json();
      return Promise.reject({ message: `Error: ${response.status}`, data: errorData });
    }

    return response.json();
  } catch (error) {
    return Promise.reject({ message: 'Network Error', error });
  }
};

export default customFetch;
